import { fetch } from '@utils/utils';
import * as T from '@modules/bicycles/_bicyclesTypes';

const getBicycle = ({ addError }) => async (id: string): Promise<T.Bicycle> => {
  try {
    const response: any = await fetch(`/metropolis/api/bi/bicycles/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Bicycle = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export { getBicycle };



// WEBPACK FOOTER //
// ./src/modules/bicycles/_bicyclesActions.ts